import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const PovinnaPole = {
	name: NAME,
	apiProvider,
	router,
};
